import { render } from "./BillPaymentsModal.vue?vue&type=template&id=04048bef"
import script from "./BillPaymentsModal.vue?vue&type=script&lang=js"
export * from "./BillPaymentsModal.vue?vue&type=script&lang=js"

import "./BillPaymentsModal.vue?vue&type=style&index=0&id=04048bef&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__